import {
  BackendServerActionType,
  BodyModel,
  ButtonElementModel,
  CastUtility,
  CellElementModel,
  ColumnHeaderElementModel,
  DevelopConditionListViewScript,
  DevelopScriptServicePack,
  DialogViewInfo,
  EditType,
  GocooEngineConfig,
  InputPartsBaseModel,
  LabelElementModel,
  LinkElementModel,
  ListPanelElementModel,
  MessageType,
  PanelModel,
  PanelType,
  ResponseDataModel,
  RowCellElementModel,
  ValidateCheckUtility,
  ViewDialogType,
  ViewType,
} from '@ktvs8/gocoo-engine-front-end';
import { ApplicationUserUtility } from 'src/app/utility/application-user-utility';
import { SapAndInvoiceArrivalDateDialogEdit } from '../Dialog/sap-and-invoice-arrivaldate-dialog-edit';
import SapAndInvoiceArrivalDateDialogEditItem from '../Dialog/sap-and-invoice-arrivaldate-dialog-item.json';

export class InvoiceConditionList implements DevelopConditionListViewScript {
  /**
   * スクリプト名
   */
  scriptName: string = 'invoiceConditionList';

  /**
   * 初期処理
   * @param panelModels パネルのモデルリスト
   * @param service gocoo-engineで使用できるサービス
   */
  init(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack): void {
    //権限制御
    const canSearch = this.canSearchInvoiceByLoginUser();
    if (!canSearch) {
      service.moveViewService.moveOrigin();
    }
    this.hiddenRegisterButton(panelModels);
  }

  /**
   * 終了処理
   * @param panelModels パネルのモデルリスト
   * @param service gocoo-engineで使用できるサービス
   */
  destroy(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack): void {}

  /**
   * SAP伝票番号登録ボタンの表示・非表示を設定する
   * @param panelModels
   */
  hiddenRegisterButton(panelModels: Map<PanelType, PanelModel>) {
    const listElement = (panelModels.get(PanelType.ListPanel) as ListPanelElementModel).listElementModel;

    listElement.headerModel.headers.forEach((header) => {
      if (header.columnName === 'SapNumberButton') {
        header.isHidden = ApplicationUserUtility.loginUserIsProduction();
      }
    });
  }

  /**
   * ボタンを押下した時の処理
   * @param panelModels パネルのモデルリスト
   * @param clickedButtonElement 押下したボタンの要素モデル
   * @param service  gocoo-engineで使用できるサービス
   */
  clickedButton(
    panelModels: Map<PanelType, PanelModel>,
    clickedButtonElement: ButtonElementModel,
    service: DevelopScriptServicePack
  ): void {
    //SAP伝票番号
    if (clickedButtonElement.id.includes('SapNumber')) {
      this.showSapEditDialog(panelModels, clickedButtonElement, service);
    }
  }

  /**
   * SAP伝票番号のダイアログを表示する
   * @param panelModels
   * @param clickedButtonElement
   * @param service
   */
  showSapEditDialog(
    panelModels: Map<PanelType, PanelModel>,
    clickedButtonElement: ButtonElementModel,
    service: DevelopScriptServicePack
  ) {
    const index = this.getRowIndexFromButtonId(clickedButtonElement);
    const listElement = (panelModels.get(PanelType.ListPanel) as ListPanelElementModel).listElementModel;
    const bodyModel = listElement.bodyModel;

    const sapNumberCell = bodyModel.rows[index].getCell('SapNumber');
    const invoiceArrivalDateCell = bodyModel.rows[index].getCell('InvoiceArrivalDate');
    if (sapNumberCell && invoiceArrivalDateCell) {
      const sapNumber = sapNumberCell.cellModel.value;
      const invoiceArrivalDate = invoiceArrivalDateCell.cellModel.value;
      const sendRecord = { SapNumber: sapNumber, InvoiceArrivalDate: invoiceArrivalDate };
      const dialogViewInfo: DialogViewInfo = {
        dialogViewLayoutInfo: {
          width: 500,
          height: 370,
        },
        dataType: 'Invoice',
        dialogType: ViewDialogType.Edit,
        editType: EditType.Edit,
        item: SapAndInvoiceArrivalDateDialogEditItem,
        script: new SapAndInvoiceArrivalDateDialogEdit(),
        sendDataToDialog: sendRecord,
      };
      service.dialogService.showViewDialog(dialogViewInfo).then((registerRecord) => {
        if (ValidateCheckUtility.isNull(registerRecord)) {
          return;
        }
        if (registerRecord['SapNumber'] !== undefined) {
          this.setSapNumber(registerRecord['SapNumber'], sapNumberCell);
        }

        if (registerRecord['InvoiceArrivalDate'] !== undefined) {
          this.setInvoiceArrivalDate(registerRecord['InvoiceArrivalDate'], invoiceArrivalDateCell);
        }

        this.updateSapNumberAndInvoiceArrivalDate(
          bodyModel.rows[index],
          registerRecord,
          sapNumberCell,
          service,
          listElement.headerModel.headers,
          bodyModel
        );
      });
    }
  }

  /**
   * SAP伝票番号をセットする
   * @param sap セットする値
   * @param sapNumberCell セットするセル
   */
  setSapNumber(sap: string, sapNumberCell: CellElementModel) {
    sapNumberCell.cellModel.value = sap;
  }

  /**
   * SAP伝票番号をセットする
   * @param sap セットする値
   * @param sapNumberCell セットするセル
   */
  setInvoiceArrivalDate(invoiceArrivalDate: string, invoiceArrivalDateCell: CellElementModel) {
    invoiceArrivalDateCell.cellModel.value = invoiceArrivalDate;
  }

  updateSapNumberAndInvoiceArrivalDate(
    row: RowCellElementModel,
    registerRecord: any,
    sapNumberCell: CellElementModel,
    service: DevelopScriptServicePack,
    headers: ColumnHeaderElementModel[],
    bodyModel: BodyModel
  ): void {
    const request = Object.assign(row.commonDBValue.getKeyValueForEditPanel(), registerRecord);

    service.dataTransmissionService.registerRecord(
      ViewType.ConditionList,
      'Invoice',
      request,
      () => {
        this.fetchRecord(row, service, headers, bodyModel);
      },
      null,
      false
    );
  }

  fetchRecord(
    row: RowCellElementModel,
    service: DevelopScriptServicePack,
    headers: ColumnHeaderElementModel[],
    bodyModel: BodyModel
  ): void {
    //更新したレコードのみ再表示
    service.dataTransmissionService
      .fetchRecord(
        ViewType.ConditionList,
        'Invoice',
        { TicketKey: row.commonDBValue.ticketKey },
        (res: ResponseDataModel) => {
          row.setupCells(res.data, row.rowNo, headers);
          this.fetchedList(bodyModel, headers);
        }
      )
      .then(() => {
        service.messageService.clearMessage();
        service.messageService.addMessage('データを更新しました。', MessageType.Info, true);
      });
  }

  /**
   * 押下されたボタンの行番号を取得する
   * @param clickedButtonElement
   * @returns
   */
  getRowIndexFromButtonId = (clickedButtonElement: ButtonElementModel) =>
    CastUtility.anyToNumber(clickedButtonElement.id.split('_')[1]);

  /**
   * リンクを押下した時の処理
   * @param panelModels パネルのモデルリスト
   * @param clickedLinkElement 押下したリンクの要素モデル
   * @param service  gocoo-engineで使用できるサービス
   */
  clickedLink(
    panelModels: Map<PanelType, PanelModel>,
    clickedLinkElement: LinkElementModel,
    service: DevelopScriptServicePack
  ): void {}

  /**
   * input-partsのイベント発生時の処理
   * @param inputPartsModel イベントが発生したinput-partsのモデル
   * @param panelModels パネルのモデルリスト
   * @param service gocoo-engineで使用できるサービス
   */
  inputPartsEvent(
    inputPartsModel: InputPartsBaseModel,
    panelModels: Map<PanelType, PanelModel>,
    service: DevelopScriptServicePack
  ): void {}

  /**
   * 一覧画面のデータを取得した後の処理
   * @param bodyModel 一覧部分のボディー
   * @param headers 一覧部分のヘッダー
   */
  fetchedList(bodyModel: BodyModel, headers: ColumnHeaderElementModel[]) {
    bodyModel.rows.forEach((row) => {
      this.displayPaymentAlert(row);
      this.setDesignClass(row);
    });
  }

  displayPaymentAlert(row: RowCellElementModel) {
    const deadlineCell = row.getCell('PaymentDeadline');
    const alertStartDateCell = row.getCell('AlertStartDate');
    const statusCell = row.getCell('StatusName');
    const today = new Date();

    if (alertStartDateCell == undefined || deadlineCell == undefined || statusCell == undefined) {
      return;
    }
    if (statusCell.cellModel.value != '未支払' || alertStartDateCell.cellModel.value == null) {
      return;
    }

    const alertStartDate = new Date(alertStartDateCell.cellModel.value);
    if (today >= alertStartDate) {
      (deadlineCell.cellModel as LabelElementModel).icon =
        '<i class="bi bi-exclamation-circle-fill" title="支払期限が迫っています"></i>';
    }
  }

  setDesignClass(row: RowCellElementModel) {
    const sapNumberButtonCell = row.getCell('SapNumberButton');
    if (sapNumberButtonCell) {
      sapNumberButtonCell.cellModel.label = '<i class="bi bi-pencil-fill"></i>';
      sapNumberButtonCell.cellModel.class.push('sap-number-button');
    }

    const statusCell = row.getCell('StatusName');
    if (statusCell == undefined) {
      return;
    }

    if (statusCell.cellModel.value == '未支払') {
      statusCell.cellModel.class.push('pay-not-finished');
    } else if (statusCell.cellModel.value == '支払済') {
      statusCell.cellModel.class.push('pay-finished');
    }
  }

  validationCheck(
    targetValidationPanel: PanelType,
    actionType: BackendServerActionType,
    panelModels: Map<PanelType, PanelModel>,
    service: DevelopScriptServicePack
  ): boolean {
    return true;
  }

  /**
   * 現在ログインしているユーザーが請求書管理を操作できるかどうかを判定する
   */
  canSearchInvoiceByLoginUser(): boolean {
    // 制作（管理者）、法務・コンプラは操作可
    const userRole = GocooEngineConfig.loginUser.userRole;
    if (userRole === 'ProductionManager' || userRole === 'Legal') {
      return true;
    }

    return false;
  }
}
